import {
  IChecklist,
  IChecklistCreatedPartnerDetail,
  IChecklistDetail,
  IChecklistPartnerPortalDetail,
} from '~/Models/DTO/CheckList.model';
import { useQuery, useMutation, useQueryClient } from 'react-query';

import { useProvider } from '~/Hooks';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';

export const useRequestChecklist = () => {
  // hooks
  const { currentProvider } = useProvider();
  const queryClient = useQueryClient();

  const { isLoading, error, data, dataUpdatedAt } = useQuery(
    [REQUEST_ACTIONS.GET_CHECK_LIST, currentProvider?.uuid],
    async () =>
      requestReactQuery<IChecklist>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.CHECK_LIST, {
          domain: currentProvider?.domain || '',
        }),
        config: { method: 'GET' },
      }),
  );

  const { error: checklistUpdateError, isLoading: isChecklistUpdateLoading, mutate } = useMutation(
    async (checklist: IChecklist) => {
      const response = requestReactQuery<IChecklist>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.CHECK_LIST, {
          domain: currentProvider?.domain || '',
        }),
        data: checklist,
        config: { method: 'PUT' },
      });
      queryClient?.invalidateQueries(REQUEST_ACTIONS.GET_CHECK_LIST);
      return response;
    },
  );

  const normalChecklist = data?.normal;
  const partnerPortalChecklist = data?.partnergram;
  const createdPartnerChecklist = data?.createdPartner;

  const updateNormalChecklist = (checklist: Partial<IChecklistDetail>) => {
    if (normalChecklist) {
      mutate({
        normal: { ...normalChecklist, ...checklist },
      });
    }
  };

  const updatePartnerPortalChecklist = (checklist: Partial<IChecklistPartnerPortalDetail>) => {
    if (partnerPortalChecklist) {
      mutate({
        partnergram: { ...partnerPortalChecklist, ...checklist },
      });
    }
  };

  const updateCreatedPartnerChecklist = (checklist: Partial<IChecklistCreatedPartnerDetail>) => {
    if (createdPartnerChecklist) {
      mutate({
        createdPartner: { ...createdPartnerChecklist, ...checklist },
      });
    }
  };

  return {
    partnerPortalChecklist,
    normalChecklist,
    createdPartnerChecklist,
    updatePartnerPortalChecklist,
    updateNormalChecklist,
    updateCreatedPartnerChecklist,
    isCheckListLoading: isLoading,
    isUpdatingChecklistLoading: isChecklistUpdateLoading,
    checklistError: error,
    checklistUpdateError,
    dataUpdatedAt,
  };
};
